export enum SortColumnEnum {
    Name = "Name",
    Capacity = "Capacity",
    HitRate = "HitRate"
}
export function MapSortName(column: SortColumnEnum) {
    let sortName = column.toString();
    switch (column) {
        case SortColumnEnum.Name:
            sortName = "Name";
            break;
        case SortColumnEnum.Capacity:
            sortName = "Capacity";
            break;
        case SortColumnEnum.HitRate:
            sortName = "Availability";
            break;
    }
    return sortName;
}